import React, { FC } from 'react'

import { useNativeEmoji } from 'components/block/emoji/emoji.hooks'
import { convertCountryCodeToEmoji } from 'functions/convertCountryCodeToEmoji'

import { Countries } from './Countries'
import { CountryList } from './Countries.types'
import { CountriesView } from './CountriesView'

export const CountriesCommon: FC<{
  countries: Countries
  currentUserCountriesIds: string[]
}> = ({ countries, currentUserCountriesIds }) => {
  const isSupportNativeEmoji = useNativeEmoji()

  const _countries: CountryList = countries.map(
    ({ country: { id, code, name } }) => {
      const text = isSupportNativeEmoji
        ? `${convertCountryCodeToEmoji(code)} ${name}`
        : name
      return {
        id,
        text,
        isWithFlag: true,
        itemHighlighted: currentUserCountriesIds.includes(id),
      }
    }
  )
  return <CountriesView countries={_countries} />
}
